import type { ComponentProps, Dispatch, SetStateAction } from 'react'

import { FacetCombobox } from './facet-combobox'
import {
  type SupplierFilterState,
  SUPPLIER_DIRECTORY_FILTER_OPTIONS
} from './filter-state'
import { SupplierSearchInput } from './search-input'
import { SupplierFilters } from './supplier-filters'

type Props = {
  search: string
  onSearchChange: (search: string) => void
  filters: SupplierFilterState
  onFiltersChange: Dispatch<SetStateAction<SupplierFilterState>>
  statusFilters?: ComponentProps<typeof SupplierFilters>['statusFilters']
}

export function SupplierDirectoryToolbar({
  search,
  onSearchChange,
  filters,
  onFiltersChange,
  statusFilters
}: Props) {
  return (
    <div className='flex flex-col gap-2 sm:flex-row sm:items-center'>
      <SupplierSearchInput value={search} onChange={onSearchChange} />

      <div className='flex flex-col gap-2 sm:ml-auto sm:flex-row sm:flex-wrap sm:items-center'>
        <FacetCombobox
          label='Country'
          options={SUPPLIER_DIRECTORY_FILTER_OPTIONS.countries}
          selected={filters.countries}
          onSelectedChange={countries =>
            onFiltersChange(prev => ({ ...prev, countries }))
          }
        />
        <FacetCombobox
          label='Operations & Capabilities'
          options={SUPPLIER_DIRECTORY_FILTER_OPTIONS.capabilityGroups}
          selected={filters.capabilityGroups}
          onSelectedChange={capabilityGroups =>
            onFiltersChange(prev => ({ ...prev, capabilityGroups }))
          }
        />
        <FacetCombobox
          label='Certifications'
          options={SUPPLIER_DIRECTORY_FILTER_OPTIONS.certifications}
          selected={filters.certifications}
          onSelectedChange={certifications =>
            onFiltersChange(prev => ({ ...prev, certifications }))
          }
          className='sm:w-[13rem]'
        />
        <SupplierFilters
          value={filters}
          onChange={onFiltersChange}
          options={SUPPLIER_DIRECTORY_FILTER_OPTIONS}
          statusFilters={statusFilters}
        />
      </div>
    </div>
  )
}
